<template>
  <div class="banner" style="z-index: -1;">
    <van-swipe :autoplay="3000">
      <van-swipe-item v-for="(image, index) in indexData.banner" :key="index">
        <router-link :to="image.url || '/'">
          <img class="img" :alt="image.name" :src="image.pic" width="100%" />
        </router-link>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>
<script>
export default {
  name: "BannerCom",
  props: {
    indexData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>
